function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#636E95"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.5 12.833c2.577 0 4.667-2.089 4.667-4.666 0-2.578-2.09-4.667-4.667-4.667S5.833 5.59 5.833 8.167s2.09 4.666 4.667 4.666zm0-7c1.289 0 2.333 1.045 2.333 2.334 0 1.288-1.044 2.333-2.333 2.333-1.289 0-2.333-1.045-2.333-2.333 0-1.289 1.044-2.334 2.333-2.334z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M17.5 7C19.433 7 21 5.433 21 3.5S19.433 0 17.5 0 14 1.567 14 3.5 15.567 7 17.5 7zm0-4.667c.644 0 1.167.523 1.167 1.167s-.523 1.167-1.167 1.167-1.167-.523-1.167-1.167.523-1.167 1.167-1.167zM17.5 8.167c-1.293.001-2.549.432-3.57 1.225-3.196-3.183-8.366-3.173-11.55.022C.86 10.942.004 13.01 0 15.167c0 .644.522 1.166 1.167 1.166.644 0 1.166-.522 1.166-1.166 0-3.222 2.612-5.834 5.834-5.834 3.221 0 5.833 2.612 5.833 5.834 0 .644.522 1.166 1.167 1.166.644 0 1.166-.522 1.166-1.166.003-1.367-.342-2.712-1.003-3.909 1.517-1.198 3.718-.94 4.916.577.487.616.753 1.379.754 2.165 0 .644.522 1.167 1.167 1.167.644 0 1.166-.523 1.166-1.167 0-3.222-2.611-5.833-5.833-5.833z",
  transform: "translate(2.333 8.167)"
})));

var SvgPeopleOutline = function SvgPeopleOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPeopleOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/people-outline.f225f30e.svg";
export { ForwardRef as ReactComponent };